import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/teachCenter/tecent-meeting-icon.png';
import _imports_1 from '@/assets/images/teachCenter/meeting-icon.png';

const _withScopeId = n => (_pushScopeId("data-v-05fa217f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "meeting-card"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "meeting-image",
  alt: ""
}, null, -1));

const _hoisted_3 = {
  key: 1,
  class: "meeting-right"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "status-icon"
}, null, -1));

const _hoisted_5 = {
  class: "meeting-info"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "meeting-icon",
  alt: ""
}, null, -1));

const _hoisted_7 = {
  class: "meeting-detail"
};
const _hoisted_8 = {
  class: "meeting-other"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "会议号：", -1));

const _hoisted_10 = {
  class: "meeting-num"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = {
  key: 2,
  class: "meeting-right meeting-right-style"
};
const _hoisted_13 = {
  class: "meeting-other"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "会议号：", -1));

const _hoisted_15 = {
  class: "meeting-num"
};
const _hoisted_16 = ["href"];
import useTecentMeeting from '../hooks/useTecentMeeting';
import clipboard from '@/plugins/clipboard.js';
export default /*#__PURE__*/_defineComponent({
  props: {
    meetingId: String,
    showClose: {
      type: Boolean,
      default: true
    }
  },
  emits: ['handleDeleteMeeting'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      getTecentMeetingInfo,
      meetingInfo
    } = useTecentMeeting();
    props.meetingId && getTecentMeetingInfo(props.meetingId);

    const formateMeetingStatus = status => {
      if (status === 0) {
        return '未开始';
      } else if (status === 1) {
        return '进行中';
      } else if (status === 2) {
        return '已结束';
      } else if (status === 3) {
        return '已取消';
      }
    }; // 复制


    const handleCopyMeetingCode = async data => {
      try {
        await clipboard(data);
        ElMessage.success('会议号已复制到您的剪切板');
      } catch (error) {
        ElMessage.error('会议号复制失败');
      }
    };

    return (_ctx, _cache) => {
      var _unref2, _unref3;

      const _component_Close = _resolveComponent("Close");

      const _component_el_icon = _resolveComponent("el-icon");

      return _unref(meetingInfo) ? (_openBlock(), _createElementBlock("section", _hoisted_1, [__props.showClose ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        class: "close-icon",
        onClick: _cache[0] || (_cache[0] = $event => emit('handleDeleteMeeting'))
      }, {
        default: _withCtx(() => [_createVNode(_component_Close)]),
        _: 1
      })) : _createCommentVNode("", true), _hoisted_2, __props.showClose ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", {
        class: _normalizeClass(["meeting-status", {
          'meeting-status-living': _unref(meetingInfo).meeting_status === 1,
          'meeting-status-end': _unref(meetingInfo).meeting_status === 2,
          'meeting-status-cancel': _unref(meetingInfo).meeting_status === 3
        }])
      }, [_hoisted_4, _createTextVNode(" " + _toDisplayString(formateMeetingStatus(+_unref(meetingInfo).status)), 1)], 2), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(meetingInfo).meeting_code), 1), _createElementVNode("i", {
        class: "copy-icon",
        onClick: _cache[1] || (_cache[1] = $event => handleCopyMeetingCode(_unref(meetingInfo).meeting_code))
      })]), _createElementVNode("a", {
        href: (_unref2 = _unref(meetingInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.meeting_url,
        target: "_blank",
        class: "meeting-link"
      }, "进入会议 >", 8, _hoisted_11)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(meetingInfo).meeting_code), 1), _createElementVNode("i", {
        class: "copy-icon",
        onClick: _cache[2] || (_cache[2] = $event => handleCopyMeetingCode(_unref(meetingInfo).meeting_code))
      })]), _createElementVNode("a", {
        href: (_unref3 = _unref(meetingInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.meeting_url,
        target: "_blank",
        class: "meeting-link"
      }, "进入会议 >", 8, _hoisted_16)]))])) : _createCommentVNode("", true);
    };
  }

});